import { Component, EventEmitter, Output, ViewChild, ElementRef, Input } from '@angular/core'
import { Modal } from 'bootstrap'
import { CreateZohoTicketForAppsClient } from 'src/app/shared/services/ppv.api'
import { ToastrService } from 'ngx-toastr'

@Component({
   selector: 'app-zoho-ticket-modal',
   templateUrl: './zoho-ticket-modal.component.html',
   styleUrls: ['./zoho-ticket-modal.component.scss'],
   standalone: false,
})
export class ZohoTicketModalComponent {
   zohoFeedback = ''
   @Input() department = ''
   @Input() subject = ''
   @Input() channel = ''
   @Input() practiceSKey = 0
   @Output() submitTicket = new EventEmitter<string>()
   @ViewChild('notesModal') modalContent!: ElementRef
   public bootstrapModal: Modal

   constructor(public createZohoTicketForAppsClient: CreateZohoTicketForAppsClient, private toastr: ToastrService) {}

   openModal() {
      this.bootstrapModal = new Modal(this.modalContent.nativeElement)
      this.bootstrapModal.show()
   }

   createTicket() {
      this.createZohoTicketForAppsClient
         .createZohoTicket(this.practiceSKey, this.zohoFeedback, this.subject, this.channel, this.department)
         .subscribe({
            next: (response) => {
               this.toastr.success('Your message has been sent', 'Success', {
                  positionClass: 'toast-center-center',
               })
               console.log('Successfully issued a ticket for zoho: ', response)
            },
            error: (error) => {
               console.error('Eror creating a zoho ticket: ', error)
            },
         })

      this.bootstrapModal.hide()
   }
}
